module.exports = __webpack_public_path__ + "img/744.46c1d175.jpg";